import React from 'react';
import { useParams } from 'react-router-dom';
import { Progress, ErrorPanel } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';
import { useRepository, useTagDetails } from '../../hooks/quay.esm.js';
import { useQuayViewPermission } from '../../hooks/useQuayViewPermission.esm.js';
import { rootRouteRef } from '../../routes.esm.js';
import PermissionAlert from '../PermissionAlert/PermissionAlert.esm.js';
import { QuayTagDetails } from '../QuayTagDetails/component.esm.js';

const QuayTagPage = () => {
  const rootLink = useRouteRef(rootRouteRef);
  const { repository, organization } = useRepository();
  const { digest } = useParams();
  const hasViewPermission = useQuayViewPermission();
  if (!digest) {
    throw new Error("digest is not defined");
  }
  const { loading, value } = useTagDetails(organization, repository, digest);
  if (!hasViewPermission) {
    return /* @__PURE__ */ React.createElement(PermissionAlert, null);
  }
  if (loading) {
    return /* @__PURE__ */ React.createElement("div", { "data-testid": "quay-tag-page-progress" }, /* @__PURE__ */ React.createElement(Progress, { variant: "query" }));
  }
  if (!value?.data) {
    return /* @__PURE__ */ React.createElement(ErrorPanel, { error: new Error("no digest") });
  }
  return /* @__PURE__ */ React.createElement(
    QuayTagDetails,
    {
      rootLink,
      layer: value.data.Layer,
      digest
    }
  );
};

export { QuayTagPage, QuayTagPage as default };
//# sourceMappingURL=component.esm.js.map
